'use strict';

angular.module('floatingDiv', [])
.directive('stickyTitle', function ($document) {
	return function (scope, elem, attrs) {

		var stickyTitleHandler = function(){
			var offsetTop = $(document).scrollTop();
			var titleTop = angular.element(elem.parents()[0]).offset().top;
			var classToToggle = attrs.stickyTitle;
			if(offsetTop >= titleTop){
				if(!elem.hasClass(classToToggle)){
					elem.toggleClass(classToToggle);
				}
			}
			else{
				if(elem.hasClass(classToToggle)){
					elem.toggleClass(classToToggle);
				}
			}
		};

		angular.element($document).bind('scroll', stickyTitleHandler);

		scope.$on('$destroy', function(){
			angular.element($document).unbind('scroll', stickyTitleHandler);
		});
	};
});
